export default __webpack_public_path__ + "static/media/wallpaper_swap.a46d75dc.svg";